import { Action, ActionType, FrameStencil, MarkerType, StencilType } from "../../types";
import {
  getPlayerActionFromReceivingHandoffLayer,
  isHandoffAction,
  isReceivingHandoffLayer,
} from "./frame-stencil-filters";
import { refreshMovements } from "./refresh-movements";

export interface ClearActionProps {
  stencils: FrameStencil[];
  action: Action;
}

export const clearAction = ({
  stencils,
  action,
}: ClearActionProps): { clearedStencils: FrameStencil[]; clearedAction: Action } => {
  const drawStencilsWithoutAction = stencils.filter((s) => s.id !== action.id);
  const clearedStencils = drawStencilsWithoutAction.map((s): FrameStencil => {
    switch (s.stencilType) {
      case StencilType.MARKER: {
        if (s.markerType === MarkerType.PLAYER && s.movements[0]?.id === action.id) return { ...s, movements: [] };
        else if (s.markerType === MarkerType.BALL && s.movements.some((m) => m.id === action.id) && s.movements[0])
          return { ...s, movements: [s.movements[0]] };
        else return s;
      }

      case StencilType.ACTION: {
        switch (s.actionType) {
          case ActionType.PLAYER: {
            if (s.nextPlayerAction === action.id) return { ...s, nextPlayerAction: null };
            else return s;
          }
          case ActionType.BALL: {
            if (s.nextBallAction === action.id) return { ...s, nextBallAction: null };
            else return s;
          }
          case ActionType.HANDOFF: {
            return s;
          }
          case ActionType.POSSESSION: {
            // if possession is next on a handoff, and is a receiving handoff layer, convert back to player action
            if (isHandoffAction(action) && action.nextAction === s.id && isReceivingHandoffLayer(s)) {
              const { nextBallAction: _, ...restS } = s;
              return {
                ...restS,
                actionType: ActionType.PLAYER,
                layerType: getPlayerActionFromReceivingHandoffLayer(s.layerType),
              };
            } else
              return {
                ...s,
                nextPlayerAction: s.nextPlayerAction === action.id ? null : s.nextPlayerAction,
                nextBallAction: s.nextBallAction === action.id ? null : s.nextBallAction,
              };
          }
        }
      }
    }
  });

  const clearedAction: Action = ((): Action => {
    switch (action.actionType) {
      case ActionType.PLAYER:
        return { ...action, nextPlayerAction: null };
      case ActionType.BALL:
        return { ...action, nextBallAction: null, nextPlayer: null, prevPlayer: null, playerActionEnd: null };
      case ActionType.HANDOFF:
        return { ...action, nextPlayer: null, prevPlayer: null };
      case ActionType.POSSESSION:
        return { ...action, nextPlayerAction: null, nextBallAction: null };
    }
  })();

  return { clearedStencils: refreshMovements(clearedStencils), clearedAction };
};
